import BreadcrumbWrapper from '../BreadcrumbWrapper';
import UserList from './UserList';
import UserForm from './UserForm';

const Users = () => {
  return (
    <div className="flex flex-col gap-4">
      <BreadcrumbWrapper crumbArray={[{ path: '/users', label: 'Users' }]} />

      <h1 className="text-2xl font-bold">Users</h1>
      <div className="flex justify-between">
        <p>Manage users of the Stork Club Admin Portal</p>
        <UserForm />
      </div>
      <UserList />
    </div>
  );
};

export default Users;
